// import constant
import {
    SET_USER_ACCOUNT,RESET_ALL
} from '../constant';

const initialValue = {
    isAuthenticated: false
}
const account = (state = initialValue, action) => {
    switch (action.type) {
        case SET_USER_ACCOUNT:
            return {
                ...state,
                ...action.data
            };
            case RESET_ALL: {
                return initialValue
                };  
        default:
            return state;
    }
}

export default account;